/* Pedacito de Cielo · v4
   - Chips de opción en cards (cambian foto, precio, link y variante)
   - Cantidad +/-
   - Agregar al carrito por AJAX (/cart/add.js). El popup-carrito ya
     detecta cualquier /cart/add y se abre solo; aquí solo actualizamos
     el contador del header con el evento cart:update de Horizon. */
(function () {
  if (window.pdc4Ready) return;
  window.pdc4Ready = true;

  function money(cents) {
    var n = (cents / 100).toFixed(2).replace(/\.00$/, '');
    return '$' + n.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function toast(text) {
    var el = document.querySelector('.pdc4-toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'pdc4-toast';
      el.setAttribute('role', 'status');
      document.body.appendChild(el);
    }
    el.textContent = text;
    el.classList.add('is-visible');
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.classList.remove('is-visible'); }, 2200);
  }

  function refreshCartCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var ev = new Event('cart:update', { bubbles: true });
        ev.detail = { resource: cart, sourceId: 'pdc4', data: { source: 'pdc4', itemCount: cart.item_count } };
        document.dispatchEvent(ev);
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch(function () {});
  }

  function addToCart(btn) {
    var id = btn.getAttribute('data-variant-id');
    if (!id || btn.classList.contains('is-loading')) return;
    var scope = btn.closest('[data-pdc-buy]');
    var qtyInput = scope ? scope.querySelector('[data-pdc-qty-input]') : null;
    var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
    var label = btn.innerHTML;
    btn.classList.add('is-loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty }] })
    })
      .then(function (r) {
        return r.json().then(function (json) {
          if (!r.ok) throw new Error(json.description || 'Error');
          return json;
        });
      })
      .then(function () {
        btn.classList.remove('is-loading');
        btn.textContent = 'Agregado ✓';
        refreshCartCount();
        document.dispatchEvent(new CustomEvent('pdc4:added', { detail: { variantId: id, quantity: qty } }));
        setTimeout(function () { btn.innerHTML = label; }, 1800);
      })
      .catch(function (err) {
        btn.classList.remove('is-loading');
        toast(err.message || 'No se pudo agregar. Intenta de nuevo.');
      });
  }

  function selectOption(chip) {
    var card = chip.closest('[data-pdc-card]');
    if (!card) return;
    card.querySelectorAll('[data-pdc-option]').forEach(function (c) {
      c.setAttribute('aria-pressed', c === chip ? 'true' : 'false');
    });
    var d = chip.dataset;
    var img = card.querySelector('[data-pdc-img]');
    if (img && d.img) {
      img.src = d.img;
      if (d.srcset) img.srcset = d.srcset;
      img.alt = d.alt || '';
    }
    card.querySelectorAll('[data-pdc-url]').forEach(function (a) { a.href = d.url; });
    var name = card.querySelector('[data-pdc-name]');
    if (name && d.name) name.textContent = d.name;
    var now = card.querySelector('[data-pdc-price-now]');
    var before = card.querySelector('[data-pdc-price-before]');
    var save = card.querySelector('[data-pdc-price-save]');
    var price = Number(d.price), compare = Number(d.compare || 0);
    var onSale = compare > price;
    if (now) now.textContent = d.priceFmt || money(price);
    if (before) { before.textContent = onSale ? (d.compareFmt || money(compare)) : ''; before.hidden = !onSale; }
    if (save) { save.textContent = onSale ? 'Ahorras ' + (d.saveFmt || money(compare - price)) : ''; save.hidden = !onSale; }
    var btn = card.querySelector('[data-pdc-add]');
    if (btn) {
      btn.setAttribute('data-variant-id', d.variantId || '');
      var available = d.available === 'true';
      btn.disabled = !available;
      var long = btn.querySelector('.pdc4-btn__long');
      var short = btn.querySelector('.pdc4-btn__short');
      if (long) long.textContent = available ? 'Agregar al carrito' : 'Agotado';
      if (short) short.textContent = available ? 'Agregar' : 'Agotado';
    }
  }

  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-pdc-add]');
    if (add) { e.preventDefault(); addToCart(add); return; }

    var opt = e.target.closest('[data-pdc-option]');
    if (opt) { e.preventDefault(); selectOption(opt); return; }

    var step = e.target.closest('[data-pdc-qty]');
    if (step) {
      var input = step.parentElement.querySelector('[data-pdc-qty-input]');
      if (!input) return;
      var v = (parseInt(input.value, 10) || 1) + (step.getAttribute('data-pdc-qty') === 'plus' ? 1 : -1);
      input.value = Math.max(1, Math.min(99, v));
    }
  });
})();

/* Carrusel genérico (tienda): [data-pdc-carrusel] con .pdc4-grid, puntos, flechas y movimiento
   automático (data-auto = segundos, 0 = apagado). Mismo comportamiento que "Más vendidos". */
(function () {
  function init(root) {
    if (root.dataset.ready) return; root.dataset.ready = '1';
    var track = root.querySelector('.pdc4-grid');
    var dots = root.querySelector('[data-pdc-car-dots]');
    var ctrl = root.querySelector('.pdc4-mv__ctrl');
    var prev = root.querySelector('[data-pdc-car-step="-1"]');
    var next = root.querySelector('[data-pdc-car-step="1"]');
    if (!track) return;
    function cards() { return track.querySelectorAll('.pdc4-card'); }
    function stepSize() { var c = cards()[0]; if (!c) return track.clientWidth; return c.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0); }
    function perPage() { return window.innerWidth < 750 ? 1 : 4; }
    function pages() { return Math.max(1, Math.ceil(cards().length / perPage())); }
    function update() {
      if (!track.clientWidth) return;
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
      var n = pages(), i = track.scrollLeft >= max ? n - 1 : Math.round(track.scrollLeft / (stepSize() * perPage()));
      if (dots.children.length !== n) dots.innerHTML = new Array(n + 1).join('<i></i>');
      [].forEach.call(dots.children, function (d, k) { d.classList.toggle('on', k === Math.min(i, n - 1)); });
      ctrl.hidden = n <= 1 || track.scrollWidth - track.clientWidth < 4;
    }
    function jump(left) {
      track.style.scrollBehavior = 'auto'; track.style.scrollSnapType = 'none';
      track.scrollLeft = left;
      track.style.scrollBehavior = ''; track.style.scrollSnapType = '';
      update();
    }
    /* Si el desplazamiento suave no arranca (pestaña en segundo plano), salta directo */
    function go(dir, porCard) {
      var start = track.scrollLeft;
      var target = Math.max(0, Math.min(track.scrollWidth - track.clientWidth, start + stepSize() * (porCard ? 1 : perPage()) * dir));
      track.scrollTo({ left: target, behavior: 'smooth' });
      setTimeout(function () { if (Math.abs(track.scrollLeft - start) < 2 && Math.abs(target - start) > 2) jump(target); }, 450);
    }
    var hastaTs = 0, encima = false, enPantalla = false, reloj = null, arranque = null;
    /* Espera antes del primer movimiento al entrar a la sección, para que se alcance a ver la primera card */
    var espera = Number(root.dataset.espera || 1500);
    function pausa(ms) { hastaTs = Date.now() + ms; }
    root.addEventListener('click', function (e) {
      var st = e.target.closest('[data-pdc-car-step]');
      if (st) { go(Number(st.dataset.pdcCarStep)); pausa(8000); }
    });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);

    var segs = Number(root.dataset.auto || 0);
    var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function avanza() {
      if (encima || !enPantalla || document.hidden || Date.now() < hastaTs || !track.clientWidth) return;
      var ae = document.activeElement; if (ae && root.contains(ae) && ae.matches(':focus-visible')) return;
      if (track.scrollWidth - track.clientWidth < 4) return;
      if (track.scrollLeft >= track.scrollWidth - track.clientWidth - 2) {
        track.scrollTo({ left: 0, behavior: 'smooth' });
        setTimeout(function () { if (track.scrollLeft > 2) jump(0); }, 600);
      } else go(1, true);
    }
    function reinicia() { clearInterval(reloj); if (segs > 0 && !reducido) reloj = setInterval(avanza, segs * 1000); }
    /* Se revisa con la posición en pantalla (al entrar arranca tras la espera; al salir se detiene) */
    function revisa() {
      var r = track.getBoundingClientRect(), h = window.innerHeight;
      var antes = enPantalla; enPantalla = r.height > 0 && r.top < h * 0.8 && r.bottom > h * 0.2;
      if (enPantalla && !antes) {
        update();
        clearInterval(reloj); clearTimeout(arranque);
        if (segs > 0 && !reducido) arranque = setTimeout(function () { avanza(); reinicia(); }, espera);
      }
    }
    window.addEventListener('scroll', revisa, { passive: true });
    window.addEventListener('resize', revisa);
    /* Al cambiar de pestaña el panel puede pasar de oculto a visible */
    document.addEventListener('click', function () { setTimeout(function () { enPantalla = enPantalla && track.clientWidth > 0; revisa(); }, 50); });
    if (segs > 0 && !reducido) {
      root.addEventListener('mouseenter', function () { encima = true; });
      root.addEventListener('mouseleave', function () { encima = false; pausa(1500); });
      ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) { track.addEventListener(ev, function () { pausa(8000); }, { passive: true }); });
    }
    update();
    revisa();
  }
  function all() { document.querySelectorAll('[data-pdc-carrusel]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();

/* Barra de beneficios en loop infinito: duplica los items hasta cubrir el ancho y mueve la cinta
   la mitad de su largo (las dos mitades son idénticas, así el salto no se nota). */
(function () {
  var VEL = 50; /* px por segundo */
  function init(row) {
    if (row.dataset.marquee) return; row.dataset.marquee = '1';
    var items = [].slice.call(row.querySelectorAll('.pdc4-trust__item'));
    if (!items.length) return;
    var track = document.createElement('div');
    track.className = 'pdc4-trust__track';
    row.classList.add('is-marquee');
    items.forEach(function (it) { track.appendChild(it); });
    row.appendChild(track);
    var base = track.innerHTML;
    var mitad = base;
    track.innerHTML = mitad;
    var guard = 0;
    while (track.scrollWidth < Math.max(window.innerWidth, 1440) && guard++ < 10) { mitad += base; track.innerHTML = mitad; }
    var ancho = track.scrollWidth;
    track.innerHTML = mitad + mitad;
    [].forEach.call(track.children, function (el, i) { if (i * 2 >= track.children.length) el.setAttribute('aria-hidden', 'true'); });
    track.style.setProperty('--pdc-marquee-s', Math.max(10, Math.round(ancho / VEL)) + 's');
  }
  function all() { document.querySelectorAll('.pdc4-trust__row').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();

/* Animaciones de entrada al hacer scroll (sutiles). Marca elementos con data-pdc-r y les agrega
   .is-in cuando entran a la pantalla. Los grupos de cards entran escalonados. */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var SOLOS = [
    '.pdc4-center-head', '.pdc4-mv__head', '.pdc4-cat__head', '.pdc4-nos__head', '.pdc4-grupo__head', '.pdc4-resenas__head',
    '.pdc4-media2__text', '.pdc4-qhome__text', '.pdc4-nos__text', '.pdc4-ritual__text', '.pdc4-familia__text', '.pdc4-caroma__text',
    '.pdc4-quiz', '.pdc4-hogar__kit', '.pdc4-contacto__card', '.pdc4-contacto__info', '.pdc4-busq__vacio', '.pdc4-cat__ghead',
    '.pdc4-nos__cta-in', '.pdc4-news__inner', '.pdc4-mv__carrusel', '.pdc4-tambien .pdc4-car', '.pdc4-catalogo .pdc4-car'
  ];
  var IMGS = ['.pdc4-nos__img', '.pdc4-hogar__img', '.pdc4-ritual__img', '.pdc4-caroma__img', '.pdc4-media2__img', '.pdc4-qhome__img'];
  var GRUPOS = ['.pdc4-grid', '.pdc4-fams', '.pdc4-nos__grid', '.pdc4-resenas__grid', '.pdc4-cols__grid', '.pdc4-faq__list', '.pdc4-busq__cats', '.pdc4-busq__otros', '.pdc4-pasos', '.pdc4-familia__grid'];
  var HERO = ['.pdc4-hero__text > *', '.pdc4-nos__hero .pdc4-nos__text > *', '.pdc4-aromas__title > div > *', '.pdc4-thead__text > *', '.pdc4-busq__head .pdc4__wrap > *'];
  var HERO_IMG = ['.pdc4-hero__media', '.pdc4-nos__img--hero'];

  function marcar(root) {
    var lista = [];
    function add(el, tipo, d) {
      if (!el || el.hasAttribute('data-pdc-r') || el.closest('[data-pdc-r]')) return;
      el.setAttribute('data-pdc-r', tipo || 'up');
      if (d) el.style.setProperty('--pdc-d', d + 's');
      lista.push(el);
    }
    HERO.forEach(function (sel) { root.querySelectorAll(sel).forEach(function (el, i) { add(el, 'up', Math.min(i, 6) * 0.08); }); });
    HERO_IMG.forEach(function (sel) { root.querySelectorAll(sel).forEach(function (el) { add(el, 'zoom', 0.15); }); });
    SOLOS.forEach(function (sel) { root.querySelectorAll(sel).forEach(function (el) { add(el, 'up'); }); });
    IMGS.forEach(function (sel) { root.querySelectorAll(sel).forEach(function (el) { add(el, 'zoom'); }); });
    GRUPOS.forEach(function (sel) {
      root.querySelectorAll(sel).forEach(function (g) {
        if (g.closest('.pdc4-mv__carrusel, .pdc4-car, [data-pdc-r]')) return;
        [].forEach.call(g.children, function (ch, i) { add(ch, 'up', (i % 4) * 0.08); });
      });
    });
    return lista;
  }
  function enVista(el) { var r = el.getBoundingClientRect(); return r.top < window.innerHeight * 0.92 && r.bottom > 0; }
  function mostrar(el) { el.classList.add('is-in'); }

  function init(root) {
    var els = marcar(root || document);
    if (!els.length) return;
    document.documentElement.classList.add('pdc4-anim');
    if (!('IntersectionObserver' in window)) { els.forEach(mostrar); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { mostrar(e.target); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { if (enVista(el)) mostrar(el); else io.observe(el); });
    /* Respaldo: si por algo el observador no avisa, revisa al hacer scroll y al final muestra todo */
    function revisa() { els.forEach(function (el) { if (!el.classList.contains('is-in') && enVista(el)) mostrar(el); }); }
    window.addEventListener('scroll', revisa, { passive: true });
    setTimeout(function () { revisa(); }, 1500);
    /* Al cambiar de pestaña en la tienda o filtrar, lo nuevo aparece sin esperar */
    document.addEventListener('click', function () { setTimeout(revisa, 60); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
